// extracted by mini-css-extract-plugin
export default {"row":"account-details_row__B2A84","capitalize":"account-details_capitalize__4F45w"};